import * as React from 'react'

const SvgLogoutOutlined = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      stroke="#60636B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
    />
    <polyline
      points="16 17 21 12 16 7"
      stroke="#60636B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line x1="21" y1="12" x2="9" y2="12" stroke="#60636B" strokeWidth="2" strokeLinecap="round" />
  </svg>
)
export default SvgLogoutOutlined
